module.exports = __webpack_public_path__ + "static/media/1022750.a10a25c2.jpg";